/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ProvidersInputs */

const en_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Providers`)
};

const zh_hans1_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务商`)
};

const pt_br2_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provedores`)
};

const es_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proveedores`)
};

const fr_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fournisseurs`)
};

const de_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anbieter`)
};

const ru_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщики`)
};

const it_footer_providers = /** @type {(inputs: Footer_ProvidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provider`)
};

/**
* | output |
* | --- |
* | "Providers" |
*
* @param {Footer_ProvidersInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_providers = /** @type {((inputs?: Footer_ProvidersInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ProvidersInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_providers(inputs)
	if (locale === "pt-BR") return pt_br2_footer_providers(inputs)
	if (locale === "es") return es_footer_providers(inputs)
	if (locale === "fr") return fr_footer_providers(inputs)
	if (locale === "de") return de_footer_providers(inputs)
	if (locale === "ru") return ru_footer_providers(inputs)
	if (locale === "it") return it_footer_providers(inputs)
	return en_footer_providers(inputs)
});